"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Logger {
    logSuccess(message) {
        //process.stdout.write(`\x1b[32msuccess\x1b[0m ${message}\n`)
    }
    logInfo(message) {
        //process.stdout.write(`\x1b[34minfo\x1b[0m ${message}\n`)
    }
    logError(message) {
        //process.stdout.write(`\x1b[31merror\x1b[0m ${message}\n`)
    }
    logWarning(message) {
        //process.stdout.write(`\x1b[33mwarning\x1b[0m ${message}\n`)
    }
}
exports.Logger = Logger;
exports.default = new Logger();



// WEBPACK FOOTER //
// ./gatsby-builder/logger/Logger.ts